<template>
  <div class="pm-dialog-progress-at">

    <div class="vs-row flex justify-center">
      <div @mousedown="selectedInput = 0" >
        <vs-input-number
          v-model="hour"
          color="#bdbdbd"
          :min="0"
          :max="23"
          class="progress-at-input"
          :class="[
            ( ( !hour && hour !== 0 )  ? 'input-null' : ( !validHour ? 'input-invalid' : 'input-any' ) ),
            ( this.selectedInput === 0 ? 'border-selected' : null )
          ]"
        />
      </div>
      <div class="flex input-label">
      :
      </div>
      <div @mousedown="selectedInput = 1">
        <vs-input-number
          v-model="minute"
          color="#bdbdbd"
          :min="0"
          :max="59"
          class="progress-at-input"
          :class="[
            ( ( !minute && minute !== 0 ) ? 'input-null' : ( !validMinute ? 'input-invalid' : 'input-any' ) ),
            ( this.selectedInput === 1 ? 'border-selected' : null )
          ]"
        />
      </div>
    </div>


    <div class="vs-row flex justify-center candidate-list">
      <div v-for="(master,index) in masterList" :key="index" class="pm-dialog-progress-at-col" @mousedown="onKeyDown(master.id)" >
        <vs-chip
          color="#828282"
          onMouseOut="this.style.background='#828282'"
          onMouseOver="this.style.background='#346c88'"
        >
          {{ master.name }}
        </vs-chip>
      </div>
    </div>

    <div class="vs-row flex justify-center">
      <vs-button
        class="current-time-button"
        color="#828282"
        onMouseOut="this.style.background='#828282'"
        onMouseOver="this.style.background='#2d9cdb'"
        @mousedown="onSetNow"
      >現在時刻</vs-button>
      <vs-button
        class="clear-button"
        color="#828282"
        onMouseOut="this.style.background='#828282'"
        onMouseOver="this.style.background='#2d9cdb'"
        @mousedown="onClear"
      >クリア</vs-button>
    </div>
    <div class="flex justify-center">
      <vs-button
        :color="isValidTime ? '#2d9cdb' : '#bdbdbd'"
        :disabled="!isValidTime"
        class="save-button"
        @mousedown="onSubmit(false)"
      >
        保存
      </vs-button>
      <vs-button
        :color="isValidTime ? '#2d9cdb' : '#bdbdbd'"
        :disabled="!isValidTime"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import Vue from "vue";
const { mapState } = createNamespacedHelpers("portMasterDestinationWork");
import moment from "moment-timezone";
export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
  },
  data() {
    return {
      selectedInput: 0,
      hour: null,
      minute: null,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
      selectedDateDisplay1: state => state.selectedDateDisplay1,
    }),
    masterList() {
      return [
        { id: 0, name: 0 },
        { id: 1, name: 1 },
        { id: 2, name: 2 },
        { id: 3, name: 3 },
        { id: 4, name: 4 },
        { id: 5, name: 5 },
        { id: 6, name: 6 },
        { id: 7, name: 7 },
        { id: 8, name: 8 },
        { id: 9, name: 9 },
      ];
    },
    isValidTime(){
      if ( !this.validHour || !this.validMinute ) {
        return false;
      }
      const dateStr = moment(moment().valueOf()).local().format("YYYYMMDD")
      const dispDate = dateStr.slice(0,4) + '-' + dateStr.slice(4,6) + '-' + dateStr.slice(6,8);
      const newDateStr = dispDate + " " + this.hour + ":" + this.minute + ":00";
      const targetDate = new Date(newDateStr);
      Vue.$log.debug("targetDate",!!targetDate,targetDate);
      return !!targetDate;
    },
    validHour() {
      return this.hour === 0 || this.hour && !isNaN(this.hour) &&  Number(this.hour) < 24
    },
    validMinute() {
      return this.minute === 0 || this.minute && !isNaN(this.minute) &&  Number(this.minute) < 60
    },
  },
  methods: {
    initData() {
      this.selectedInput = 0;
      this.hour   = this.valueMap && this.valueMap.value && this.valueMap.value[this.valueMap.progress] ? moment(this.valueMap.value[this.valueMap.progress].seconds * 1000).local().format("HH") : "" ;
      this.minute = this.valueMap && this.valueMap.value && this.valueMap.value[this.valueMap.progress] ? moment(this.valueMap.value[this.valueMap.progress].seconds * 1000).local().format("mm") : "" ;
    },
    onKeyDown(key){
      if ( this.selectedInput === 0) {
        this.hour = this.hour && ( this.hour * 10 + key ) % 100 < 24 ? ( this.hour * 10 + key ) % 100 : key;
      }
      if ( this.selectedInput === 1) {
        this.minute = this.minute && ( this.minute * 10 + key ) % 100 < 60 ? ( this.minute * 10 + key ) % 100 : key;
      }
    },
    onSetNow() {
      this.hour = moment().local().format("HH");
      this.minute = moment().local().format("mm");
    },
    onClear() {
      if ( this.selectedInput !== 1) {
        this.hour   = "";
      }
      if ( this.selectedInput === 1) {
        this.minute = "";
      }
    },
    onSubmit(isUpdateTimeStamp) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      const dateStr = moment(moment().valueOf()).local().format("YYYYMMDD")
      const dispDate = dateStr.slice(0,4) + '/' + dateStr.slice(4,6) + '/' + dateStr.slice(6,8);
      const newDateStr = dispDate + " " + this.hour + ":" + this.minute + ":00";
      const newDate = new Date(newDateStr);
      Vue.$log.debug("newDateStr", newDateStr, newDate);

      const updateKeyValueMap = {};
      updateKeyValueMap['progress'] = this.valueMap.progress;
      updateKeyValueMap[this.columnKey] = {};
      updateKeyValueMap[this.columnKey][this.valueMap.progress] = isNaN(newDate) ? null : newDate;
      this.$emit('updateValue', this.taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-progress-at {
  .vs-con-input-label  {
    width: 4rem;
    margin: 2rem 0;
    .vs-input--input {
      height: 3rem;
      text-align: center;
      background-color: $pm-white;
    }
  }
  .current-time-button {
    margin: 1rem;
    width:  8rem;
  }
  .clear-button {
    margin: 1rem;
    width:  8rem;
  }
  .border-selected {
    border: 0.2rem solid $pm-blue !important;
    box-sizing: border-box;
  }
  .input-label {
    padding: 1.4rem 0.4rem;
  }
  .input-any {
    background-color: $pm-white;
  }
  .input-null {
    background-color: $pm-light-gray;
  }
  .input-invalid {
    background-color: rgba(203,57,79,0.4); //#CB4B4F;
  }
  .progress-at-input {
    margin: 0.2rem 0.5rem !important;
    border-radius: 5px;
    input {
      height: 4rem !important;
      border-radius: 5px;
      font-size: 150% !important;
    }
  }
  .vs-input-number  {
    margin-bottom: 2rem !important;
    padding: 1rem 0;
    height: 4rem;
    width: 4rem;
    border: 0.05rem solid $pm-mouse-gray;
    border-radius: 0.2rem;
    input {
      min-width: 2.4rem ;
    }
    &--button-less{
      height: 1.5rem;
      min-width: 1.8rem;
      transform:translate(1.0rem,3.2rem) !important;
    }
    &--button-plus{
      height: 1.5rem;
      min-width: 1.8rem;
      transform:translate(-1.0rem,3.2rem) !important;
    }
  }


  .candidate-list{
    margin-top: 2rem;
  }
  .pm-dialog-progress-at-col {
    margin:0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:6px;
      height:3rem;
      font-size: 120%;
      min-width: 3rem;
    }
  }
}
</style>

